import { StrikeMethodApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';

import { normalizeStrikeMethods } from './normalizers';
import { StrikeMethod } from './types';

export class VoladeumStrikeMethods extends Axios {
  async list(): Promise<VoladeumResponse<StrikeMethod[]>> {
    const res = await this.get<VoladeumResponse<StrikeMethodApi[]>>('/v1/lookups/strike-methods');
    return {
      success: res.success,
      error: res.error,
      data: normalizeStrikeMethods(res.data),
    };
  }
}
